export const Flights = {  
  TopicWorkspaceEdit: 'PFXProductWCDropdown',
  MetadataAdminShowTest: 'MetadataAdminShowTest',
  DeepLinkToAIAssistant: 'DeepLinkToAIAssistant',
};
